// Home に入ったときのイントロ。ぼかした Home の上にマークが浮かび、中心からの波紋で揺れて消える。
// #intro が無い（同じタブで再生済み、または Home 以外）なら何もしない。
(function () {
  var root = document.getElementById('intro');
  if (!root) return;
  var cv = root.querySelector('canvas');
  var KEY = 'mf-intro-seen';
  var BLUR = 6;
  var INK = [0.086, 0.086, 0.086];
  // 秒。波紋そのものの速さはシェーダーの t*2.2 で決まり、ここを縮めても変わらない
  var T = { inStart: 0.05, inEnd: 0.7, rippleStart: 0.35, ripplePeak: 1.0, logoOut: 1.35, logoGone: 2.0, bgOut: 1.7, end: 2.4 };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroLogo = document.querySelector('.hero-logo');
  var raf = 0, start = 0, done = false;

  function markSeen() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function finish() {
    if (done) return;
    done = true;
    cancelAnimationFrame(raf);
    markSeen();
    if (heroLogo) { heroLogo.style.opacity = ''; heroLogo.style.animation = ''; }
    root.remove();
  }
  function skip() {
    root.style.transition = 'opacity .4s';
    root.style.opacity = '0';
    if (heroLogo) heroLogo.style.opacity = '';
    setTimeout(finish, 400);
  }

  // WebGL の立ち上げ（コンテキスト作成とシェーダーのコンパイル）は、ページの最初の描画が済んでから行う。
  // 読み込み直後に行うと、端末によっては初期化が終わるまで最初の 1 枚が画面に出ない（19-seo C1）
  var gl, pr, tex;
  function U(n) { return gl.getUniformLocation(pr, n); }
  function initGL() {
    gl = cv.getContext('webgl', { premultipliedAlpha: false, alpha: true });
    if (!gl) return false;

    var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var fs = [
      'precision highp float;',
      'uniform sampler2D tex; uniform vec2 res; uniform float t,amp,logoA,ringA,blur; uniform vec3 ink;',
      'float logo(vec2 uv){ return texture2D(tex,uv).a; }',
      'void main(){',
      '  vec2 uv=gl_FragCoord.xy/res; uv.y=1.-uv.y;',
      '  vec2 q=(uv-.5)*vec2(res.x/res.y,1.);',
      '  float d=length(q);',
      // 中心のごく近くだけ弱めるのは、向きが定まらず一点が膨らんで見えるのを防ぐため
      '  float w=sin(d*20.-t*2.2)*exp(-d*1.6)*smoothstep(.0,.06,d);',
      '  vec2 s=uv+normalize(q+1e-5)*w*amp*.0075;',
      '  float a=0.; float r=blur/res.y;',
      '  for(int i=-1;i<=1;i++)for(int j=-1;j<=1;j++) a+=logo(s+vec2(float(i),float(j))*r);',
      '  a=a/9.*logoA;',
      // 背景にも輪の明暗をうっすら乗せ、波紋が画面全体へ広がって見えるようにする
      '  float ring=max(0.,w)*amp*ringA*.10;',
      '  vec3 c=mix(vec3(1.),ink,a/max(a+ring,1e-4));',
      '  gl_FragColor=vec4(c,clamp(a+ring,0.,1.));',
      '}'
    ].join('\n');
    function sh(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
      return s;
    }
    try {
      pr = gl.createProgram();
      gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs));
      gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs));
      gl.linkProgram(pr);
      gl.useProgram(pr);
    } catch (e) { return false; }
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    tex = gl.createTexture();
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    return true;
  }

  var logoImg = new Image();
  logoImg.crossOrigin = 'anonymous';
  var off = document.createElement('canvas');

  function layout() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(innerWidth * dpr);
    cv.height = Math.round(innerHeight * dpr);
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    // 縦長のマークなので、画面の高さ 46%・幅 60% の枠に収まる大きさにする
    off.width = cv.width;
    off.height = cv.height;
    var g = off.getContext('2d');
    g.clearRect(0, 0, off.width, off.height);
    var k = Math.min(innerHeight * 0.46 / logoImg.naturalHeight, innerWidth * 0.6 / logoImg.naturalWidth);
    var w = logoImg.naturalWidth * k * dpr, h = logoImg.naturalHeight * k * dpr;
    g.drawImage(logoImg, (off.width - w) / 2, (off.height - h) / 2, w, h);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, off);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  }

  function clamp(x) { return Math.min(1, Math.max(0, x)); }
  function ease(x) { return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
  function prog(t, a, b) { return ease(clamp((t - a) / (b - a))); }

  function frame(now) {
    // 起点は最初のフレーム。裏のタブで開いた場合も、表に出てから頭から再生する
    if (!start) start = now;
    var t = (now - start) / 1000;
    var logoA, amp, blur, bgA, end;
    if (reduce) {
      logoA = prog(t, 0, 0.4) * (1 - prog(t, 1.0, 1.4));
      amp = 0; blur = 0; bgA = 1 - prog(t, 1.2, 1.6); end = 1.6;
    } else {
      logoA = prog(t, T.inStart, T.inEnd) * (1 - prog(t, T.logoOut, T.logoGone));
      blur = (1 - prog(t, T.inStart, T.inEnd)) * 14 + prog(t, T.logoOut, T.logoGone) * 6;
      amp = prog(t, T.rippleStart, T.ripplePeak) * (1 - 0.45 * prog(t, T.ripplePeak, T.end));
      bgA = 1 - prog(t, T.bgOut, T.end);
      end = T.end;
    }
    gl.uniform2f(U('res'), gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform1f(U('t'), t);
    gl.uniform1f(U('amp'), amp);
    gl.uniform1f(U('logoA'), logoA);
    gl.uniform1f(U('ringA'), bgA);
    gl.uniform1f(U('blur'), blur * (cv.height / innerHeight));
    gl.uniform3fv(U('ink'), INK);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    root.style.setProperty('--blur', (BLUR * bgA).toFixed(2) + 'px');
    root.style.setProperty('--tint', (0.12 * bgA).toFixed(3));
    // Home の大きな文字ロゴはマークと重ならないよう隠しておき、マークが消えたあとに浮かび上がらせる
    if (heroLogo) heroLogo.style.opacity = (0.85 * prog(t, end - 1.0, end)).toFixed(3);
    if (t < end) raf = requestAnimationFrame(frame); else finish();
  }

  function play() {
    if (done) return;
    // CSS の保険（6s）が効き始めたあとに覆いを戻すと、読み始めたページに急にかぶさる
    if (performance.now() > 5500) { finish(); return; }
    // CSS の保険はここで同期して止める。rAF の後ろに回すと、裏のタブで開いたときに保険で消えた覆いがかぶさり直す
    root.style.animation = 'none';
    if (heroLogo) heroLogo.style.animation = 'none';
    // 2 回待つのは、ぼかした Home の 1 枚目が画面に出たのを確かめてから WebGL を立ち上げるため
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (done) return;
        if (!initGL()) { finish(); return; }
        layout();
        raf = requestAnimationFrame(frame);
      });
    });
  }

  // マークと hero 画像の両方が揃ってから再生する。hero が遅い回線でも 1.5 秒で諦めて始める
  var heroImg = document.querySelector('.hero > img');
  var heroReady = heroImg && heroImg.decode
    ? Promise.race([heroImg.decode().catch(function () {}), new Promise(function (r) { setTimeout(r, 1500); })])
    : Promise.resolve();
  var logoReady = new Promise(function (res, rej) { logoImg.onload = res; logoImg.onerror = rej; });
  logoImg.src = root.getAttribute('data-logo');
  Promise.all([logoReady, heroReady]).then(play, finish);

  root.addEventListener('click', skip);
  addEventListener('keydown', function (e) { if (!done && !e.metaKey && !e.ctrlKey && !e.altKey) skip(); });
  addEventListener('resize', function () { if (!done && gl) layout(); });
})();
